import React, { useState } from 'react';
import styles from './ProfilCard.module.css';

const ProfilCard = ({ userData, onProfilePictureChange, onProfilePictureDelete, onProfileSave, selectedFile, previewImage, successMessage, handleFileChange, uploadProfilePicture }) => {
  return (
    <div className={styles.profilCard}>
      {/* Titlu vizibil pe toate rezolutiile */}
      <h4 className={styles.desktopTitle}>Profil</h4>
      {/* Titlu vizibil doar pe mobil */}
    
      <div className={styles.profilePictureSection}>
        <div className={styles.profilePictureWrapper}>
          <div className={styles.profilePictureContainer}>
            <img
              src={previewImage || userData?.profile_picture || 'https://via.placeholder.com/150'}
              alt="Profile"
              className={styles.profilePictureImg}
            />
            {previewImage && <div className={styles.previewBadge}>Preview</div>}
          </div>
          <div className={styles.profilePictureInfo}>
              <h5 className={styles.profilePictureTitle + ' ' + styles.hideOnMobile}>Fotografie de profil</h5>
            <p className={styles.profilePictureDescription}>
              JPG, PNG sau GIF. Dimensiune maxima 5MB.<br />
              Imaginea va fi redimensionata automat la 400x400px.
            </p>
            <div className={styles.profilePictureActions}>
              <label className={styles.btnUploadNew}>
                {selectedFile ? 'Schimba imaginea' : 'Incarca imagine'}
                <input type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'none' }} />
              </label>
              {selectedFile && (
                <button className={styles.btnSavePicture} onClick={uploadProfilePicture}>
                  Salveaza
                </button>
              )}
              {userData?.profile_picture && (
                <button className={styles.btnDeletePicture} onClick={onProfilePictureDelete}>
                  Sterge
                </button>
              )}
            </div>
            {successMessage && <div className={styles.alertSuccess}>{successMessage}</div>}
          </div>
        </div>
      </div>
      <form className={styles.profileForm} onSubmit={onProfileSave}>
        <div className={styles.formGroupModern}>
          <label className={styles.formLabelModern}>Nume utilizator</label>
          <input
            type="text"
            className={styles.formInputModern}
            value={userData?.username || ''}
            placeholder="Introdu numele tau"
            readOnly
          />
        </div>
        <div className={styles.formGroupModern}>
          <label className={styles.formLabelModern}>Adresa de email</label>
          <input
            type="email"
            className={styles.formInputModern}
            value={userData?.email || ''}
            placeholder="email@example.com"
            disabled
          />
          <small className={styles.formHint}>Email-ul nu poate fi modificat</small>
        </div>
        <button type="submit" className={styles.btnSaveProfile} disabled>
          Salveaza modificarile
        </button>
      </form>
    </div>
  );
};

export default ProfilCard;
